import styled, {ThemeProps, keyframes} from 'styled-components';
import {Theme} from './../../../../../theme/types';
import {Column, Row} from '../../common/Layouts/Layouts';

const placeHolderShimmer = keyframes`
  0% {
    background-position: -46.8rem 0;
  }
  
  100% {
    background-position: 46.8rem 0; 
  }
`;

export const contentLoader = styled.div`
  background: ${props => props.theme.colors.goBrandBlue.medium};
  background-image: linear-gradient(to right, #d1e5ff 0%, #e2efff 20%, #d1e5ff 40%, #d1e5ff 100%);
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: ${props => props.theme.misc.borderRadius.small};
  margin-bottom: ${props => props.theme.spacing.small};
`;

export const SrpCardAllComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  max-width: 94rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.xlarge};

`,
);

export const SrpCardLeftComponentWrapDiv = styled.div(
  props => ` 
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    margin: 0 auto;
    width:75%;
    border-right: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    padding:${props.theme.spacing.large} ;
  
  `,
);

/*** gallery block */

export const GalaryBlockComponentWrapDiv = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:41%;  
    padding-right:${props.theme.spacing.small};
  `,
);

export const HotelImageComponentWrapDiv = styled(contentLoader)(
  props => `
    width:98%;
    border-radius:${props.theme.misc.borderRadius.large};
    height:20.6rem;
  
  `,
);

export const HotelSmallInnerWrapDiv = styled.div(
  props => `
    display: flex;
    flex-wrap:wrap;
    flex-direction: row;
    align-items: center;
    `,
);

export const HotelSmallInnerListWrap = styled(contentLoader)(
  props => `
    border-radius: ${props.theme.misc.borderRadius.base};
    margin-right:${props.theme.spacing.small};
    width:4.9rem;
    height:4.9rem;
    margin-bottom:0;
  
  `,
);

/*** hotel details */

export const HotelDetailsLoaderComponentWrapDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  
    width:59%;
    justify-content: space-between;
  `,
);

export const HotelDetailsFirstLoaderWrapDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  
    justify-content: space-between;
  `,
);

export const RatingLoaderWrapSpan = styled(contentLoader)(
  props => `
    width:9.5rem;
    height:2rem;
    margin-bottom:${props.theme.spacing.custom(8)};
  `,
);

export const HotelNameLoaderWrapDiv = styled(contentLoader)(
  props => `
    width:15.3rem;
    height:2rem;
    margin-bottom:${props.theme.spacing.custom(8)};
  `,
);

export const AddressLoaderWrapDiv = styled(contentLoader)(
  props => `

    width:9.1rem;
    height:1.2rem;
    margin-bottom:${props.theme.spacing.base};
  `,
);

export const AmminitiesLoaderWrapDiv = styled(contentLoader)(
  props => `
    width:28rem;
    height:1.4rem;
    margin-bottom:${props.theme.spacing.large};
    &:last-child{
      margin-bottom:0;
    }
  `,
);

export const SrpCardRightComponentWrapDiv = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:25%;
    padding:${props.theme.spacing.large};  
    justify-content: flex-end;
  
  `,
);

export const FirstPricingComponentWrapDiv = styled(contentLoader)(
  props => `
    width:19.3rem;
    border-radius:${props.theme.misc.borderRadius.xxxlarge};
    height:2.1rem;
  
  `,
);

export const SecondPricingComponentWrapDiv = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
  `,
);

export const StrikedPriceWrapDiv = styled(contentLoader)(
  props => `
    width:4.7rem;
    height:1.4rem; 
  `,
);

export const OriginalPriceLoaderDiv = styled(contentLoader)(
  props => `
    width:6.8rem;
    height:2rem;
  `,
);

export const TaxLoaderDiv = styled(contentLoader)(
  props => `
    width:6.3rem;
    height:2rem;
  
  `,
);
export const OfferLoaderDiv = styled(contentLoader)(
  props => `
    width:9.2rem;
    height:1.4rem;
  
  `,
);

export const PriceBtnDiv = styled(contentLoader)(
  props => `
    width:13rem;
    height:3.2rem;
    margin-top:${props.theme.spacing.xlarge};
  
  `,
);

export const AlertWrapDiv = styled(contentLoader)(
  props => `
    width:16.1rem;
    height:1.4rem;
    margin-bottom:0;
  `,
);
